import { Column, Container, Backbone } from '@smuchile/pkg-unimarc-components'
import { getGlobalStyle } from '@smuchile/pkg-unimarc-components/helpers'
import { BORDER_STYLE_GLOBAL } from 'shared/constants'

export const SideNavLoader = () => {
  return (
    <Column
      customWidth='100%'
      isWrap
      margin='5px 0 0 0'
      position='sticky'
      tagName='aside'
    >
      <Container
        backgroundColor={getGlobalStyle('--color-background-white')}
        border={BORDER_STYLE_GLOBAL}
        borderRadius={getGlobalStyle('--border-radius-md')}
        customHeight='270px'
        justifyContent='center'
        margin='12px 0'
        maxWidth='90%'
        padding='26px 20px'
      >
        <Backbone
          borderRadius={getGlobalStyle('--border-radius-md')}
          height={220}
          width={100}
        />
      </Container>
    </Column>
  )
}
